import { useEffect } from 'react'

import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { consumeConnectBankAutoOpenRequest } from '../utils/connectBankModalUiSourceStore'
import { useOpenConnectBankModal } from './useOpenConnectBankModal'

/**
 * Opens the connect bank modal on mount when the user arrived from a "connect bank" action elsewhere,
 * e.g. the dashboard widget. Call it from the Accounts page itself, not from a child that only renders in some
 * states, so the request is always consumed there.
 */
export const useAutoOpenConnectBankModal = (): void => {
  const openConnectBankModal = useOpenConnectBankModal()

  useEffect(() => {
    const uiSource = consumeConnectBankAutoOpenRequest()

    if (uiSource && isAuthorized(Scope.BankSyncWrite)) {
      openConnectBankModal(uiSource)
    }
  }, [openConnectBankModal])
}
